/** Global variable name used by the SDK command queue */
export const SDK_GLOBAL_NAME = 'collectEvent';

/** TeaAnalyticsObject key */
export const TEA_ANALYTICS_OBJECT = 'TeaAnalyticsObject';

/** Performance event name prefixes */
export const PERF_EVENT_PREFIX = 'perf_';

/** PV event name */
export const PV_EVENT_NAME = 'page_enter';

/** FCP thresholds (ms) */
export const FCP_THRESHOLDS = { good: 1800, poor: 3000 } as const;

/** LCP thresholds (ms) */
export const LCP_THRESHOLDS = { good: 2500, poor: 4000 } as const;

/** 错误事件名 */
export const ERROR_EVENT_RUNTIME = `error_runtime`;
export const ERROR_EVENT_PROMISE = `error_promise`;
export const ERROR_EVENT_RESOURCE = `error_resource`;

/** 默认错误采样率（1 = 全量） */
export const DEFAULT_ERROR_SAMPLE_RATE = 0.1;

/** 单次页面浏览内最多上报的错误条数 */
export const DEFAULT_ERROR_MAX_COUNT = 20;

/** 相同错误去重时间窗口（ms） */
export const DEFAULT_ERROR_DEDUP_WINDOW = 5000;

/** 错误字段截断长度限制 */
export const ERROR_MESSAGE_MAX_LEN = 1000;
export const ERROR_STACK_MAX_LEN = 4000;

/** 批量上报默认间隔（ms） */
export const DEFAULT_BATCH_INTERVAL = 5000;

/** 批量上报缓冲区最大条数，超出立即 flush */
export const MAX_BATCH_BUFFER_SIZE = 100;

/** 默认事件去重时间窗口（ms）。0 表示默认关闭，消费项目可按需配置 */
export const DEFAULT_EVENT_DEDUP_INTERVAL = 0;

/** 去重缓存最大条目数，超过后触发惰性清理 */
export const MAX_DEDUP_CACHE_SIZE = 100;

/** 页面停留时长事件名 */
export const PAGE_STAY_EVENT_NAME = 'page_stay';
export const MANUAL_STAY_EVENT_NAME = 'manual_stay';

/** 默认页面停留时长最小上报阈值（ms） */
export const DEFAULT_PAGE_STAY_MIN_DURATION = 1000;
